import { render } from "./whatsapp-business-settings.vue?vue&type=template&id=38b3a21d&scoped=true"
import script from "./whatsapp-business-settings.vue?vue&type=script&lang=js"
export * from "./whatsapp-business-settings.vue?vue&type=script&lang=js"

import "./whatsapp-business-settings.vue?vue&type=style&index=0&id=38b3a21d&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b3a21d"]])

export default __exports__